import { ENDPOINTS } from '@/configs/endpoints';
import call from '@/utils/api';

type FetchDocumentDownloadLinkParams = {
  documentId?: string;
  organizationId?: string;
};

type FetchDocumentDownloadLinkSuccess = {
  success: true;
  link: string;
};

type FetchDocumentDownloadLinkError = {
  success: false;
  errorMessage?: string;
};

export type FetchDocumentDownloadLinkResult = FetchDocumentDownloadLinkSuccess | FetchDocumentDownloadLinkError;

export const fetchDocumentDownloadLink = async ({
  documentId,
  organizationId,
}: FetchDocumentDownloadLinkParams): Promise<FetchDocumentDownloadLinkResult> => {
  if (!documentId || !organizationId) {
    return {
      success: false,
      errorMessage: 'Не удалось определить документ',
    };
  }

  const response = await call<{ link: string }>({
    endpoint: ENDPOINTS.documents.download(organizationId, documentId),
  });

  if (response.isError) {
    return {
      success: false,
      errorMessage: response.error.response?.data?.message ?? 'Не удалось скачать документ',
    };
  }

  return {
    success: true,
    link: response.data.link,
  };
};
